import * as React from "react";
import VideoComponent from "./VideoComponent";
import Loading from "../../../components/Loading";
import { Patient } from "../../patient/types";
import { isMobile } from "react-device-detect";

interface StoreProps {
  patient: Patient | null;
  participantId?: string;
}

interface OwnState {
  submitDisabled: boolean;
}

type Props = StoreProps;

class VideoChat extends React.PureComponent<Props, OwnState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true
    };
  }

  render() {
    const { patient, participantId } = this.props;
    return (
      <>
        <div className={"video-container flex-vertical " + (isMobile ? "mobile-container" : "")}>
          <div className="information">
            {/* Only show if Provider */}
            {patient ? (
              <div className="title m-15">
                Patient: {patient?.givenName} {patient?.familyName}
              </div>
            ) : null}
          </div>
          {participantId ? (
            <VideoComponent participantId={participantId} patient={patient} />
          ) : (
            <Loading />
          )}
        </div>
      </>
    );
  }
}

export default VideoChat;
